import { INMaxCropGroup, setDates } from "../omnia"
import { CroppingProvider, INtrApp, INtrBalance, INtrReq, INutritionPlan } from "../types"


export function setupApplications(apps: INtrApp[], croppingProvider: CroppingProvider, plans: INutritionPlan[]) {

    setDates(apps, ["ApplicationDate", "ActualDate"], true)

    for (const app of apps) {

        app.ProductRate = app.ProductRate || 0
        app.ProductAmount = app.ProductAmount || 0

        app.Cropping = croppingProvider(app.CroppingId)

        if (app.PlanId) {
            app.Plan = plans.find(p => p.NutritionPlanId == app.PlanId)
        }

        if (app.AppId && app.Plan && app.Plan.Applications) {
            app.App = app.Plan.Applications.find(a => a.NutritionPlanProductAppId == app.AppId)
        }

    }

    return apps

}

export function setupRequirements(reqs: INtrReq[], croppingProvider: CroppingProvider) {

    setDates(reqs, ["CalculationDate", "CreatedOn", "UpdatedOn"], false)
    setDates(reqs, ["SoilAnalysisDate"], true)

    for (const req of reqs) {
        req.Cropping = croppingProvider(req.CroppingId)
        req.CalculationDate = req.CalculationDate || req.UpdatedOn || req.CreatedOn
        setupErrors(req)
    }

    return reqs

}

export function setupBalance(balance: INtrBalance[], croppingProvider: CroppingProvider) {

    setDates(balance, ["InitDate"], false)

    for (const b of balance) {
        b.Cropping = croppingProvider(b.CroppingId)
    }

    return balance

}

export function setupNMaxGroups(groups: INMaxCropGroup[]): INMaxCropGroup[] {

    for (const g of groups) {

        g.NMaxAverage = g.NMaxAverage || 0
        g.NMaxDefault = g.NMaxDefault || 0

        if (g.GroupId && g.Cropping) {

            for (const c of g.Cropping) {
                c.NMaxAdjusted = c.NMaxAdjusted || 0
                c.NMaxDefault = c.NMaxDefault || 0
            }

        }
    }

    return groups

}


function setupErrors(req: INtrReq) {

    const cropChanged = (req.Cropping?.cropId != req.CropId)

    const errors = [

        cropChanged
            ? "The crop has changed since the requirements were last calculated"
            : undefined,

        req.NCalcStatusText
            ? `Nitrogen: ${req.NCalcStatusText}`
            : undefined,

        req.PkCalcStatusText
            ? `PK: ${req.PkCalcStatusText}`
            : undefined,

        req.PkDefaultModel
            ? "PK: No SRUC data - calculated using ADAS values"
            : undefined,

        req.LimeCalcStatusText
            ? `Lime: ${req.LimeCalcStatusText}`
            : undefined,

    ].filter(e => !!e)

    req.HasError = Boolean(cropChanged || req.NCalcStatus || req.PkCalcStatus || req.LimeCalcStatus || req.PkDefaultModel)
    req.ErrorText = errors.length ? errors.join("\n") : undefined

}
